import { FC } from "react";
import { useTranslation } from "react-i18next";

import Container from "components/__reusable/Container";
import type { UserManual } from "types/SupportMaterial";
import { SupportedLang } from "config/constants";

interface ContentProp {
  manuals: UserManual[];
}

const Content: FC<ContentProp> = ({ manuals }) => {
  const { i18n } = useTranslation();

  if (!manuals || manuals.length === 0) {
    return (
      <Container>
        <div className="space-y-2">
          <p className="text-xl font-bold">No content available</p>
          <p className="text-gray-600">
            There are no manuals for this category yet.
          </p>
        </div>
      </Container>
    );
  }

  return (
    <Container>
      <div className="space-y-2">
        <p className="text-xl font-bold">
          {i18n.language === SupportedLang.ja
            ? manuals[0].category_ja
            : manuals[0].category_en}
        </p>
        <ul className="ml-6 space-y-1">
          {manuals.map((manual, i) => {
            const isNumbered =
              manual.paragraph_number &&
              !isNaN(Number(manual.paragraph_number));

            return (
              <li key={i} className="flex gap-2">
                <span className="text-lg flex-shrink-0">
                  {isNumbered ? `${manual.paragraph_number}.` : "■"}
                </span>
                <div className="flex-1">
                  {manual.url ? (
                    <a
                      className="text-lg underline text-primary font-semibold hover:no-underline hover:text-primary/80"
                      href={manual.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {i18n.language === SupportedLang.ja
                        ? manual.title_ja
                        : manual.title_en}
                    </a>
                  ) : (
                    <span className="text-lg underline">
                      {i18n.language === SupportedLang.ja
                        ? manual.title_ja
                        : manual.title_en}
                    </span>
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </Container>
  );
};

export default Content;
